var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { participantsSelector, updateParticipant, } from '../../../../store/slices/participantSlice';
import useStorePreviousInt from '../../../../helpers/hooks/useStorePreviousInt';
const MicIcon = ({ userId, isRemoteParticipant }) => {
    var _a;
    _react_refresh_temp_2();
    const participant = useAppSelector((state) => participantsSelector.selectById(state, userId));
    const [volume, setVolume] = useState((_a = participant === null || participant === void 0 ? void 0 : participant.audioVolume) !== null && _a !== void 0 ? _a : 1);
    const previousVolume = useStorePreviousInt(volume);
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (typeof (participant === null || participant === void 0 ? void 0 : participant.audioVolume) !== 'undefined') {
            setVolume(participant === null || participant === void 0 ? void 0 : participant.audioVolume);
        }
    }, [participant === null || participant === void 0 ? void 0 : participant.audioVolume]);
    useEffect(() => {
        if (previousVolume && volume !== previousVolume) {
            dispatch(updateParticipant({
                id: userId,
                changes: {
                    audioVolume: volume,
                },
            }));
        }
    }, [volume, previousVolume]);
    const renderUnmuteIcon = useCallback(() => {
        return (_jsx("div", { className: "mic ltr:mr-2 rtl:ml-2 cursor-pointer", children: _jsx(Menu, { children: ({ open }) => (_jsxs(_Fragment, { children: [_jsx(Menu.Button, { children: _jsx("i", { className: "pnm-mic-unmute secondaryColor text-[10px]" }) }), _jsx(Transition, { show: open, enter: "transition duration-100 ease-out", enterFrom: "transform scale-95 opacity-0", enterTo: "transform scale-100 opacity-100 relative z-10", leave: "transition duration-75 ease-out", leaveFrom: "transform scale-100 opacity-100", leaveTo: "transform scale-95 opacity-0", children: _jsx(Menu.Items, { static: true, className: "volume-popup-wrapper origin-top-right z-10 absolute ltr:-right-6 rtl:-left-6 -top-2 mt-2 w-48 xl:w-60 py-5 px-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none", children: _jsxs("section", { className: "flex items-center", children: [_jsx("input", { type: "range", min: 0, max: 1, step: 0.05, value: volume, onChange: (event) => {
                                                setVolume(event.target.valueAsNumber);
                                            }, className: "range flex-1" }), _jsx("p", { className: "w-10 text-center text-sm", children: Math.round(volume * 100) }), _jsx("button", { className: "w-5 h-5", children: _jsx("i", { className: "pnm-speaker primaryColor" }) })] }) }) })] })) }) }));
    }, [volume]);
    const render = useMemo(() => {
        if (participant === null || participant === void 0 ? void 0 : participant.audioTracks) {
            if (participant.isMuted) {
                return (_jsx("div", { className: "mic muted mr-2 cursor-pointer", children: _jsx("i", { className: "pnm-mic-mute secondaryColor text-[10px]" }) }));
            }
            // if this user is a remote Participant then we can control volume.
            if (isRemoteParticipant) {
                return renderUnmuteIcon();
            }
            // for local user don't need
            return (_jsx("div", { className: "mic mr-2 cursor-pointer", children: _jsx("i", { className: "pnm-mic-unmute secondaryColor text-[10px]" }) }));
        }
        return null;
    }, [
        isRemoteParticipant,
        renderUnmuteIcon,
        participant === null || participant === void 0 ? void 0 : participant.audioTracks,
        participant === null || participant === void 0 ? void 0 : participant.isMuted,
    ]);
    return _jsx(_Fragment, { children: render });
};
_react_refresh_temp_1 = MicIcon;
$RefreshReg$(_react_refresh_temp_1, "MicIcon");
_react_refresh_temp_2(MicIcon, "A7NK7kFOwdCHKQj68OB5tVyzjOo=", false, () => [useAppSelector, useStorePreviousInt, useAppDispatch]);
export default MicIcon;
